import { useState } from 'react'
import ReviewCard from '@/entities/ReviewCard/index.js'
import ReviewsForm from '@/features/catalog-inside-page/ReviewsForm/ui/ReviewsForm.jsx'
import PaginationBtns from '@/shared/components/Pagination'

export const ReviewsChapter = ({
    product: { productId, productName },
    reviews,
}) => {
    if (!reviews) {
        return <h4>Загрузка...</h4>
    }

    const countView = 5 // количество отображаемых отзывов за раз
    const offset = 2 // количество показываемых кнопок пагинации

    const [countShowReviews, setCountShowReviews] = useState(countView) // количество показываемых отзывов по кнопке "показать ещё"
    const pageQuantity = Math.ceil(reviews.length / countView) // количество страниц пагинации в цифрах
    const [currentPage, setCurrentPage] = useState(1) // текущая страница пагинации по цифрам
    const [reviewsState, setReviewsState] = useState(
        reviews?.slice(0, countShowReviews)
    ) // новый массив отзывов, которые показывается в зависимости от пагиниции или кнопки "показать ещё"

    const limitReviews =
        reviewsState[reviewsState.length - 1] !== reviews[reviews.length - 1] // показаны ли все отзывы сейчас

    const handleShowMore = async () => {
        const startIndex = (currentPage - 1) * countShowReviews // начальный индекс
        const endIndex = startIndex + countShowReviews + countView // конечный индекс
        setCountShowReviews((prev) => prev + countView) // количество показываемых отзывов
        setReviewsState(reviews.slice(startIndex, endIndex)) // сам массив
    }

    const handlePaginationButton = async (pageNuber) => {
        if (countShowReviews !== countView) {
            // возвращаю количество отображаемых отзывов, если вдруг нажимали кнопку "показать ещё" и планируют ещё нажать
            setCountShowReviews(countView)
        }

        setCurrentPage(pageNuber) // устанавливаю текущую страницу
        const startIndex = (pageNuber - 1) * countView // начальный индекс
        const endIndex = startIndex + countView // конечный индекс
        setReviewsState(reviews.slice(startIndex, endIndex)) // сам массив
    }

    return (
        <div className={'ReviewsChapter'}>
            <ReviewsForm productId={productId} productName={productName} />
            {reviewsState.map((review) => (
                <ReviewCard
                    showProductLink={false}
                    key={review.review_id}
                    item={review}
                />
            ))}
            {reviews.length > countView ? (
                <div className="action">
                    <PaginationBtns
                        pageQuantity={pageQuantity}
                        currentPage={currentPage}
                        offset={offset}
                        handlePaginationButton={handlePaginationButton}
                        limitReviews={limitReviews}
                        handleShowMore={handleShowMore}
                    />
                </div>
            ) : (
                ''
            )}
        </div>
    )
}
